import React, { useState } from "react";
import "./businessOutcomeDms.css";

import {
  FiTrendingUp,
  FiPackage,
  FiMapPin,
  FiZap,
  FiUsers,
  FiBarChart2,
  FiCreditCard,
  FiSmile,
} from "react-icons/fi";
import DmsBookingModal from "./dmsBookingModal";

const outcomes = [
  {
    icon: FiTrendingUp,
    title: "Increase Sales",
    text: "Get clear visibility into primary and secondary sales, product movement and channel performance to make better sales decisions.",
  },
  {
    icon: FiPackage,
    title: "Better Inventory",
    text: "Know what stock is available across warehouses and distributors, helping you manage availability and reduce stock-out situations.",
  },
  {
    icon: FiMapPin,
    title: "Wider Retail Reach",
    text: "Give your sales team better visibility of retailers and field activity to improve market coverage and strengthen channel execution.",
  },
  {
    icon: FiZap,
    title: "Faster Operations",
    text: "Connect ordering, distributor operations, invoicing, dispatch and delivery in one flow to reduce manual work and speed up fulfillment.",
  },
  {
    icon: FiUsers,
    title: "Distributor Efficiency",
    text: "Bring distributor orders, inventory, schemes and channel operations together for smoother day-to-day distribution management.",
  },
  {
    icon: FiBarChart2,
    title: "Secondary Sales Visibility",
    text: "Track how products move through distributors and retailers with sales visibility by product, SKU, territory and customer.",
  },
  {
    icon: FiCreditCard,
    title: "Better Collections",
    text: "Improve visibility into outstanding invoices, payment status, credit limits and collection activity across your distribution network.",
  },
  {
    icon: FiSmile,
    title: "Customer Satisfaction",
    text: "Improve order visibility, product availability and coordination between distributors, sales teams and retailers.",
  },
];

const BusinessOutcomesDms = () => {
  const [showDmsModal, setShowDmsModal] = useState(false);
  
  return (
    <>
      <section className="business-outcomes-dms-section">
        <div className="business-outcomes-dms-glow" aria-hidden="true"></div>

        <div className="container">
          <div
            className="business-outcomes-dms-heading"
            data-aos="fade-up"
            data-aos-duration="800"
          >
            <span className="business-outcomes-dms-label">BUSINESS IMPACT</span>

            <h2>
              What Your Business Gets
              <span> with DMS</span>
            </h2>

            <p>
              Connect distribution operations with better visibility, faster
              execution and smarter decisions.
            </p>
          </div>
          <div className="business-outcomes-dms-grid">
            {outcomes.map((outcome, index) => {
              const Icon = outcome.icon;

              return (
                <div
                  className="business-outcome-dms-card"
                  key={outcome.title}
                  data-aos="fade-up"
                  data-aos-duration="700"
                  data-aos-delay={index * 100}
                >
                  <div className="business-outcome-dms-top">
                    <span className="business-outcome-dms-number">
                      0{index + 1}
                    </span>

                    <div className="business-outcome-dms-icon">
                      <Icon />
                    </div>
                  </div>

                  <h3>{outcome.title}</h3>

                  <p>{outcome.text}</p>

                  <span className="business-outcome-dms-line"></span>
                </div>
              );
            })}
          </div>
          <div
            className="business-outcomes-dms-cta"
            data-aos="fade-up"
            data-aos-duration="800"
            data-aos-delay="200"
          >
            <button
              type="button"
              className="business-outcomes-dms-cta-btn"
              onClick={() => setShowDmsModal(true)}
            >
              Explore Techcognics DMS
              <span>
                <FiTrendingUp />
              </span>
            </button>
          </div>
          <div
            className="business-outcomes-dms-bottom"
            data-aos="fade-up"
            data-aos-duration="700"
            data-aos-delay="400"
          >
            <strong>One connected distribution network.</strong>
            <span>Better visibility. Better execution. Better growth.</span>
          </div>
        </div>
      </section>
      <DmsBookingModal
        show={showDmsModal}
        onClose={() => setShowDmsModal(false)}
      />
    </>
  );
};

export default BusinessOutcomesDms;
